/* src/app/views/template/components/edit-template-menu/edit-template-card-stack-menu/edit-template-card-stack-menu.component.scss */
/*# sourceMappingURL=edit-template-card-stack-menu.component.css.map */
